import {
  HomeOutlined,
  UserOutlined,
  FundOutlined,
  FileProtectOutlined ,
  AuditOutlined,
  ContainerOutlined,
  ToTopOutlined,
  DiffOutlined, 
  UsergroupAddOutlined,
  GroupOutlined,
  HarmonyOSOutlined,
  WalletOutlined 

   

  // Importa aquí todos los íconos que necesites
} from '@ant-design/icons';

const iconMap: { [key: string]: React.ComponentType } = {
  home: HomeOutlined,
  user: UserOutlined,
  business:FileProtectOutlined,
  benefit:FundOutlined,
  solicitude:AuditOutlined,
  dashboardcount:HomeOutlined,
  mysolicitude:AuditOutlined,
  patient: UsergroupAddOutlined ,
  steps:AuditOutlined,
  dashboardsolicitude:HomeOutlined,
  claim:ContainerOutlined,
  turn:ToTopOutlined,
  laboratory:DiffOutlined,
  item:DiffOutlined,
  estates:GroupOutlined,
  forum:HarmonyOSOutlined,
  commision:WalletOutlined, 
  attention:AuditOutlined 
  

 


  // Agrega más íconos según sea necesario
};

export default iconMap;
